import React from 'react';
import { motion } from 'framer-motion';
export function Stats() {
  return <section className="py-6 md:py-12 border-y border-primary-card bg-primary-card/30" data-id="element-177">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6 divide-y md:divide-y-0 md:divide-x divide-primary-card" data-id="element-179">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex flex-col items-center text-center pt-2 md:pt-0" data-id="element-180">
            <span className="text-4xl md:text-5xl font-heading font-bold text-accent-cyan mb-1 md:mb-2" data-id="element-181">
              16
            </span>
            <span className="text-text-muted font-medium uppercase tracking-wider text-sm" data-id="element-182">
              Cuadernillos Técnicos
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex flex-col items-center text-center pt-4 md:pt-0" data-id="element-183">
            <span className="text-4xl md:text-5xl font-heading font-bold text-accent-cyan mb-1 md:mb-2" data-id="element-184">
              960
            </span>
            <span className="text-text-muted font-medium uppercase tracking-wider text-sm" data-id="element-185">
              Páginas de Contenido
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex flex-col items-center text-center pt-4 md:pt-0" data-id="element-186">
            <span className="text-4xl md:text-5xl font-heading font-bold text-accent-cyan mb-1 md:mb-2" data-id="element-187">
              4.9/5
            </span>
            <span className="text-text-muted font-medium uppercase tracking-wider text-sm" data-id="element-188">
              Calificación Docente
            </span>
          </motion.div>
        </div>
      </div>
    </section>;
}